import { getCountryCodes } from "../../../../app/api/getCountryCodes";
import { BaseAction } from "../../../../core/actions/BaseAction";
import { updateRecoilState } from "../../../../Orchestrator/Recoils/Events/Recoil";
import { ICountryCodes, IApiResponse } from "../../../../Orchestrator/Types/Index";


class GetCountryCodesAction extends BaseAction<ICountryCodes[], void> {
    protected override deduplicate = true;

    override async run(): Promise<ICountryCodes[] | null> {
        let countryCodeResponses: ICountryCodes[] | null = null;
        try {
            if (this.result == null) {
                const response: IApiResponse<ICountryCodes[]> = await getCountryCodes();

                if (response.status === "ok" && response.answer) {
                    const countryCodeResponse = response.answer;
                    if (countryCodeResponse) {
                        // Sort the country codes with AE (United Arab Emirates) first, then alphabetically
                        countryCodeResponse.sort((a, b) => {
                            // AE (United Arab Emirates) first
                            if (a.countryCode === "AE") return -1;
                            if (b.countryCode === "AE") return 1;
                            // Sort the rest alphabetically by label
                            return a.label.localeCompare(b.label);
                        });
                        countryCodeResponses = countryCodeResponse;
                        updateRecoilState("countryCodesAtom", countryCodeResponses);
                    } else {
                        console.warn("No country Codes found.");
                    }
                } else {
                    console.warn("Failed to fetch country Codes.");
                }
            }
        } catch (error: any) {
            console.error("Error fetching country Codes:", error);
        }
        finally {
            return countryCodeResponses;
        }
    }
}

export const getCountryCodesAction = new GetCountryCodesAction()


